import React, { useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useApp } from '@pixi/react';
import { loadingStore } from '../../../store/loadingStore';
import { isMobile } from '../../../core/helpers/isMobile';
import { gameDrawer } from '../../../services/gameDrawer';
import WebView from '../../../view/web';
import MobileView from '../../../view/mobile';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { iframeService } from '../../../services/iframeService';
import { triggerHotJarEvent } from '../../../core/helpers/triggerHotjarEvent';
import { reelsParams } from '../../../core/constants/reelConstants';

const GameViewWrapper = observer(() => {
  const { ticker } = useApp();
  const touchSpinScreenRef = useRef();
  const reelContainerRef = useRef();
  const winContainerRef = useRef();
  const [mask, setMask] = React.useState(null);

  const { hasGameInitialState } = loadingStore;
  const { maskSprite } = useMemo(() => {
    return getGameImages();
  }, []);
  useEffect(() => {
    if (hasGameInitialState) {
      gameDrawer.execute(reelContainerRef.current, winContainerRef.current,touchSpinScreenRef.current, ticker);
    }
  }, [hasGameInitialState, ticker]);

  useEffect(() => {
    if (reelContainerRef.current) {
      reelContainerRef.current.mask = mask;
    }
  }, [mask, reelContainerRef]);

  useEffect(() => {
    iframeService.sendGameIsReady();
    triggerHotJarEvent('Game is open');
  }, []);

  const { reelContainerConfig } = useMemo(() => {
    return {
      reelContainerConfig: {
        x: isMobile() ? 60 : 363,
        y: isMobile() ? 306 : 222,
        width:
          reelsParams.reduce(
            (widthFactor, reel) =>
              widthFactor + reel.iconsWidth + reel.spacing + reel.offsetForContainerBoardWidth,
            0
          ) - reelsParams[0].spacing,
        height: ((maxReel) =>
          maxReel.visibleRows * (maxReel.iconsHeight + maxReel.iconsSpacing) -
          maxReel.iconsSpacing -
          maxReel.offsetForContainerBoardHeight)(
          reelsParams.reduce(
            (max, reel) =>
              reel.visibleRows > max.visibleRows ||
              (reel.visibleRows === max.visibleRows && reel.iconsHeight > max.iconsHeight)
                ? reel
                : max,
            reelsParams[0]
          )
        ),
      },
    };
  }, []);
  const { touchSpinScreenConfig } = useMemo(() => {
    return {
      touchSpinScreenConfig: {
        x: isMobile() ? 58 : 275,
        y: isMobile() ? 291 : 140,
        width: reelContainerConfig.width,
        height: reelContainerConfig.height,
      },
    };
  }, []);

  return isMobile() ? (
    <MobileView
      setMask={setMask}
      reelContainerRef={reelContainerRef}
      winContainerRef={winContainerRef}
      touchSpinScreenRef={touchSpinScreenRef}
      reelContainerConfig={reelContainerConfig}
      touchSpinScreenConfig={touchSpinScreenConfig}
    />
  ) : (
    <WebView
      setMask={setMask}
      maskSprite={maskSprite}
      reelContainerRef={reelContainerRef}
      winContainerRef={winContainerRef}
      touchSpinScreenRef={touchSpinScreenRef}
      reelContainerConfig={reelContainerConfig}
      touchSpinScreenConfig={touchSpinScreenConfig}
    />
  );
});
export default GameViewWrapper;
